/**
 * 兼容 File 和 URL 的抽帧函数
 * @param {File|Blob|string|Object} source - 视频文件、Blob、URL字符串或包含它们的Item对象
 */
export async function generateThumbnail(source) {
    return new Promise((resolve, reject) => {
        if (!source) return reject("No source provided");

        const video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;

        let url = "";
        let isObjectUrl = false;

        // --- 核心修复逻辑：解构并识别真正的 Source ---
        try {
            if (typeof source === "string") {
                // 情况 1: 直接是 URL 字符串
                url = source;
            } else if (source instanceof File || source instanceof Blob) {
                // 情况 2: 直接是 File 或 Blob
                url = URL.createObjectURL(source);
                isObjectUrl = true;
            } else if (source.file && (source.file instanceof File || source.file instanceof Blob)) {
                // 情况 3: 是你定义的 Item 对象，包含 file 属性
                url = URL.createObjectURL(source.file);
                isObjectUrl = true;
            } else if (source.url && typeof source.url === "string") {
                // 情况 4: 是你定义的 Item 对象，只有远程 URL
                url = source.url;
            } else {
                throw new Error("Invalid source type: Argument must be File, Blob, or URL string");
            }
        } catch (err) {
            return reject(err);
        }

        video.src = url;

        video.onloadedmetadata = () => {
            // 设置到 0.5 秒，避开黑屏
            video.currentTime = 0.5;
        };

        video.onseeked = () => {
            try {
                const canvas = document.createElement("canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((blob) => {
                    // 只有创建了临时 URL 才有必要销毁
                    if (isObjectUrl) {
                        URL.revokeObjectURL(url);
                    }
                    resolve(blob);
                }, "image/jpeg", 0.7);
            } catch (err) {
                reject(err);
            }
        };

        // 加上超时处理，防止某些视频编码导致永远不触发 onseeked
        const timeout = setTimeout(() => {
            reject("Thumbnail generation timed out");
        }, 10000); // 10秒超时

        video.onerror = (e) => {
            clearTimeout(timeout);
            if (isObjectUrl) URL.revokeObjectURL(url);
            reject("Video loading error");
        };
    });
}

export function getThumbnailUrl(url) {
    const pathname = new URL(url).pathname;
    const filenameWithExt = pathname.split('/').pop();
    return `https://api.antaressocial.com/assets/thumbnail/${filenameWithExt}`;
}

export function getVideoThumbnailUrl(url) {
    const pathname = new URL(url).pathname;
    const filenameWithExt = pathname.split('/').pop();
    const videoBaseName = filenameWithExt.split('.').slice(0, -1).join('.') || filenameWithExt;

    return `https://api.antaressocial.com/assets/thumbnail/${videoBaseName}.jpg`;
}

export function getBaseName(url) {
    const pathname = new URL(url).pathname;
    const filenameWithExt = pathname.split('/').pop();
    return filenameWithExt.split('.').slice(0, -1).join('.') || filenameWithExt;
}